import { Box, Flex, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import PaymentFlowImage1 from "../../../../assets/images/akruAdmin/Group 3903.png";
import PaymentFlowImage2 from "../../../../assets/images/akruAdmin/Group 3905.png";
import Fade from "react-reveal/Fade";
const PaymentFlow = () => {
  const isXLScreen = useBreakpointValue({ base: false, xl: true });
  return (
    <Box backgroundColor="#F9F9F9">
      <Box className={isXLScreen ? "container" : "container-responsive"}>
        {/* section-1 */}
        <Flex
          paddingTop="100px"
          justifyContent="space-between"
          alignItems={{ base: "start", xl: "center" }}
          flexDirection={{ base: "column", xl: "row" }}
        >
          <Fade left>
            <Box>
              <Text
                width={{ base: "fit-content", xl: "477px" }}
                color="#000"
                fontSize={{ base: "30px", md: "40px", xl: "48px" }}
                fontStyle="normal"
                fontWeight={{ base: "600", xl: "500" }}
                lineHeight={{ base: "40px", xl: " 65px" }}
              >
                Frictionless Payment Processing
              </Text>
              <Text
                paddingTop="30px"
                width={{ base: "fit-content", xl: "554px" }}
                color="#666"
                fontSize={{ base: "16px", xl: "24px" }}
                fontStyle="normal"
                fontWeight="400"
                lineHeight={{ base: "30px", xl: " 40px" }}
              >
                Smooth and secure transaction processing via integrated
                electronic payment systems.
              </Text>
            </Box>
          </Fade>
          <Box
            position="relative"
            paddingY={{ base: "50px", xl: "0px" }}
            height={{ base: "inherit", xl: "fit-content" }}
            overflow="unset"
          >
            <Image
              height={{ base: "fit-content", xl: "400px" }}
              src={PaymentFlowImage1}
            />
          </Box>
        </Flex>

        {/* section-2 */}
        <Flex
          paddingY={{ base: "0px", xl: "120px" }}
          flexDirection={{ base: "column-reverse", xl: "row" }}
          paddingBottom={{ base: "60px", xl: "120px" }}
          justifyContent="space-evenly"
          alignItems={{ base: "start", xl: "center" }}
        >
          <Box
            position="relative"
            paddingTop={{ base: "50px", xl: "0px" }}
            height={{ base: "inherit", xl: "fit-content" }}
            overflow="unset"
          >
            <Image
              height={{ base: "fit-content", xl: "400px" }}
              src={PaymentFlowImage2}
            />
          </Box>
          <Fade right>
            <Box>
              <Text
                width={{ base: "fit-content", xl: "502px" }}
                color="#000"
                fontSize={{ base: "30px", md: "40px", xl: "48px" }}
                fontStyle="normal"
                fontWeight={{ base: "600", xl: "500" }}
                lineHeight={{ base: "40px", xl: " 65px" }}
              >
                Effective Capital Flow Management
              </Text>
              <Text
                paddingTop="30px"
                width={{ base: "fit-content", xl: "554px" }}
                color="#666"
                fontSize={{ base: "16px", xl: "24px" }}
                fontStyle="normal"
                fontWeight="400"
                lineHeight={{ base: "30px", xl: " 40px" }}
              >
                Ensure timely capital call and distribution notices, along with
                transparent tracking of capital allocation and utilization.
              </Text>
            </Box>
          </Fade>
        </Flex>
      </Box>
    </Box>
  );
};

export default PaymentFlow;
